/**
 * @generated SignedSource<<41ec5f19528fa4957e0d9efd7a739386>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddRepositoryPageQuery$variables = {
  locator: string;
  skip: boolean;
};
export type AddRepositoryPageQuery$data = {
  readonly pipeline?: {
    readonly parentProject: {
      readonly " $fragmentSpreads": FragmentRefs<"pipelineParentProjectFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type AddRepositoryPageQuery = {
  response: AddRepositoryPageQuery$data;
  variables: AddRepositoryPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddRepositoryPageQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectRest",
                "kind": "LinkedField",
                "name": "parentProject",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "pipelineParentProjectFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddRepositoryPageQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectRest",
                "kind": "LinkedField",
                "name": "parentProject",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internalId",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3e1c2492bf5f428a6b5ce11b902c5455",
    "id": null,
    "metadata": {},
    "name": "AddRepositoryPageQuery",
    "operationKind": "query",
    "text": "query AddRepositoryPageQuery(\n  $locator: String!\n  $skip: Boolean!\n) {\n  pipeline(pipelineLocator: $locator) @skip(if: $skip) {\n    parentProject {\n      ...pipelineParentProjectFragment\n      _id\n    }\n    _id\n  }\n}\n\nfragment pipelineParentProjectFragment on ProjectRest {\n  id\n  internalId\n}\n"
  }
};
})();

(node as any).hash = "c2f31685676978736eeb93eedcc246f7";

export default node;
